import YourData from "./YourData";

export default YourData;